import _round from 'lodash/round';
import _sum from 'lodash/sum';
import moment from 'moment';

import Utils from 'services/utils';

export default class DataConverter {
    static getRoundedFloatOrNull(value, precision = 2) {
        if (!value) {
            return null;
        }

        return _round(parseFloat(value), precision);
    }

    static getDecimalIntOrNull(value) {
        if (!value || value === '0') {
            return null;
        }

        return parseInt(value, 10);
    }

    static temperature(data) {
        const ranges = [];
        const average = [];

        let timestamp;

        data.forEach((entry) => {
            timestamp = moment(entry.time).valueOf();
            ranges.push([
                timestamp,
                DataConverter.getRoundedFloatOrNull(entry.MIN_TEMPERATURE),
                DataConverter.getRoundedFloatOrNull(entry.MAX_TEMPERATURE)
            ]);
            average.push([
                timestamp,
                DataConverter.getRoundedFloatOrNull(entry.MEAN_TEMPERATURE)
            ]);
        });

        return {
            ranges,
            average
        };
    }

    static touch(data) {
        const result = [];

        data.forEach((entry) => {
            result.push([
                moment(entry.time).valueOf(),
                DataConverter.getDecimalIntOrNull(entry.COUNT_TOUCH)
            ]);
        });

        return result;
    }

    static proximityNavigator(data) {
        const result = [];

        data.forEach((entry) => {
            result.push([
                moment(entry.time).valueOf(),
                DataConverter.getDecimalIntOrNull(entry.COUNT_OBJECT_PRESENT)
            ]);
        });

        return result;
    }

    static proximity(data) {
        const result = [];

        let timestamp;
        let prevStatus;
        let status;

        data.forEach((entry) => {
            timestamp = moment(entry.time).valueOf();
            status = entry.object_present ? -1 : 1;
            if (prevStatus) {
                if (status !== prevStatus) {
                    result.push([timestamp, prevStatus]);
                }
            }
            prevStatus = status;
            result.push([timestamp, status]);
        });

        return result;
    }

    static calculateInterval(start, end, itemCount = 40) {
        const seconds = (end - start) / itemCount / 1000;
        return Utils.intervalToText(seconds);
    }

    static getPureValues(data, index = 1) {
        return data.map(item => item[index]).filter(item => item !== null);
    }

    static temperatureStats(data) {
        const averages = DataConverter.getPureValues(data.average);
        const minimums = DataConverter.getPureValues(data.ranges);
        const maximums = DataConverter.getPureValues(data.ranges, 2);

        if (!averages.length) {
            return null;
        }

        return {
            lowest: `${_round(Math.min(...minimums), 2)}°C`,
            average: `${_round(_sum(averages) / averages.length, 2)}°C`,
            highest: `${_round(Math.max(...maximums), 2)}°C`
        };
    }

    static touchStats(data) {
        const values = DataConverter.getPureValues(data);

        if (!values.length) {
            return null;
        }

        return {
            'total presses': _sum(values)
        };
    }

    static proximityStats(values) {
        if (!values.length) {
            return null;
        }

        const openings = [];

        let openedAt = null;

        values.forEach(([time, status]) => {
            if (status === 1) {
                if (!openedAt) {
                    openedAt = time;
                }
            } else if (openedAt) {
                openings.push(time - openedAt);
                openedAt = null;
            }
        });

        if (openedAt) {
            const [lastTime] = values[values.length - 1];
            openings.push(lastTime - openedAt);
        }

        const result = {
            'times opened': `${openings.length}`
        };

        if (openings.length > 1) {
            const averageInterval = Math.round(_sum(openings) / openings.length / 1000);
            result['average open for'] = Utils.intervalToText(averageInterval);
        }

        return result;
    }
}



// WEBPACK FOOTER //
// ./app/services/charting/data-converter.js